export const NAME = 'company';
